import React, { useState } from "react";
import { Link } from "react-router-dom";
import { all_routes } from "../../router/all_routes";
import CountUp from "react-countup";

const ParentDashboard = () => {
  const routes = all_routes;

  // Mock data for children
  const [children] = useState([
    { id: "1", name: "Emma Johnson", grade: "10th", class: "10-A" },
    { id: "2", name: "James Johnson", grade: "8th", class: "8-B" },
  ]);

  const [selectedChildId, setSelectedChildId] = useState("1");
  const [showFABModal, setShowFABModal] = useState(false);

  const selectedChild = children.find((child) => child.id === selectedChildId);

  // Mock data for widgets
  const smartAlerts = [
    {
      id: "1",
      type: "urgent",
      message: "Math test scheduled for tomorrow",
      time: "2 hours ago",
    },
    {
      id: "2",
      type: "info",
      message: "Parent-teacher meeting next Friday",
      time: "1 day ago",
    },
    {
      id: "3",
      type: "warning",
      message: "Fee payment due in 3 days",
      time: "3 days ago",
    },
  ];

  const homeworkData = {
    due: [
      {
        subject: "Mathematics",
        title: "Algebra Problems Ch.5",
        dueDate: "Tomorrow",
      },
      { subject: "English", title: "Essay on Shakespeare", dueDate: "Aug 7" },
    ],
    overdue: [{ subject: "Science", title: "Lab Report", dueDate: "Aug 3" }],
  };

  const documentsData = {
    new: [
      { title: "Progress Report - July", type: "Report Card", date: "Aug 1" },
    ],
    pending: [
      { type: "Transfer Certificate", status: "Processing", date: "Jul 25" },
    ],
  };

  return (
    <>
      <div className="page-wrapper">
        <div className="content">
          {/* Header with Child Selector */}
          <div className="row mb-4">
            <div className="col">
              <h3 className="page-title mb-2">Good Morning, Parent! 👋</h3>
              <p className="text-muted mb-0">Hope you're having a great day</p>
            </div>
            <div className="col-auto">
              {children.length > 1 && (
                <div className="dropdown">
                  <button
                    className="btn btn-outline-primary dropdown-toggle"
                    type="button"
                    data-bs-toggle="dropdown"
                  >
                    <i className="ti ti-user me-2"></i>
                    {selectedChild?.name}
                  </button>
                  <ul className="dropdown-menu">
                    {children.map((child) => (
                      <li key={child.id}>
                        <button
                          className={`dropdown-item ${
                            selectedChildId === child.id ? "active" : ""
                          }`}
                          onClick={() => setSelectedChildId(child.id)}
                        >
                          {child.name} - {child.grade} {child.class}
                        </button>
                      </li>
                    ))}
                  </ul>
                </div>
              )}
            </div>
          </div>

          {/* Smart Alerts Widget */}
          <div className="col-12 mb-4">
            <div className="card border-start border-primary border-4">
              <div className="card-header d-flex align-items-center justify-content-between">
                <h5 className="card-title mb-0">
                  <i className="ti ti-bell me-2 text-primary"></i>Smart Alerts
                </h5>
                <span className="badge bg-primary">{smartAlerts.length}</span>
              </div>
              <div className="card-body">
                {smartAlerts.map((alert) => (
                  <div
                    key={alert.id}
                    className={`d-flex align-items-center mb-3 p-2 rounded ${
                      alert.type === "urgent"
                        ? "bg-danger-light"
                        : alert.type === "warning"
                        ? "bg-warning-light"
                        : "bg-info-light"
                    }`}
                  >
                    <div
                      className={`avatar avatar-sm me-3 ${
                        alert.type === "urgent"
                          ? "bg-danger"
                          : alert.type === "warning"
                          ? "bg-warning"
                          : "bg-info"
                      }`}
                    >
                      <i
                        className={`ti ${
                          alert.type === "urgent"
                            ? "ti-alert-triangle"
                            : alert.type === "warning"
                            ? "ti-clock"
                            : "ti-info-circle"
                        } text-white`}
                      ></i>
                    </div>
                    <div className="flex-fill">
                      <p className="mb-1 fw-semibold">{alert.message}</p>
                      <small className="text-muted">{alert.time}</small>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>

          {/* Dashboard Widgets Row */}
          <div className="row">
            {/* Child's Attendance Widget */}
            <div className="col-xxl-3 col-sm-6">
              <div className="card">
                <div className="card-body">
                  <div className="d-flex align-items-center">
                    <div className="avatar avatar-xl bg-success-transparent me-2">
                      <i className="ti ti-calendar-check fs-2"></i>
                    </div>
                    <div className="overflow-hidden flex-fill">
                      <div className="d-flex align-items-center justify-content-between">
                        <h2 className="counter text-success">
                          <CountUp end={94} />%
                        </h2>
                        <span className="badge bg-success">Excellent</span>
                      </div>
                      <p>Attendance Overview</p>
                    </div>
                  </div>
                  <div className="d-flex align-items-center justify-content-between border-top mt-3 pt-3">
                    <p className="mb-0">
                      Present:{" "}
                      <span className="text-success fw-semibold">151</span>
                    </p>
                    <span className="text-light">|</span>
                    <p className="mb-0">
                      Absent: <span className="text-danger fw-semibold">9</span>
                    </p>
                  </div>
                  <Link
                    to={routes.studentAttendanceView}
                    className="btn btn-success btn-sm mt-2 w-100"
                  >
                    View Attendance
                  </Link>
                </div>
              </div>
            </div>

            {/* Homework Overview Widget */}
            <div className="col-xxl-3 col-sm-6">
              <div className="card">
                <div className="card-body">
                  <div className="d-flex align-items-center">
                    <div className="avatar avatar-xl bg-warning-transparent me-2">
                      <i className="ti ti-book-2 fs-2"></i>
                    </div>
                    <div className="overflow-hidden flex-fill">
                      <div className="d-flex align-items-center justify-content-between">
                        <h2 className="counter text-warning">
                          <CountUp
                            end={
                              homeworkData.due.length +
                              homeworkData.overdue.length
                            }
                          />
                        </h2>
                        <span className="badge bg-warning">Tasks</span>
                      </div>
                      <p>Homework Overview</p>
                    </div>
                  </div>
                  <div className="d-flex align-items-center justify-content-between border-top mt-3 pt-3">
                    <p className="mb-0">
                      Due:{" "}
                      <span className="text-warning fw-semibold">
                        {homeworkData.due.length}
                      </span>
                    </p>
                    <span className="text-light">|</span>
                    <p className="mb-0">
                      Overdue:{" "}
                      <span className="text-danger fw-semibold">
                        {homeworkData.overdue.length}
                      </span>
                    </p>
                  </div>
                  <Link
                    to="/parent/homework"
                    className="btn btn-warning btn-sm mt-2 w-100"
                  >
                    View Homework
                  </Link>
                </div>
              </div>
            </div>

            {/* Today's Schedule Widget */}
            <div className="col-xxl-3 col-sm-6">
              <div className="card">
                <div className="card-body">
                  <div className="d-flex align-items-center">
                    <div className="avatar avatar-xl bg-info-transparent me-2">
                      <i className="ti ti-clock fs-2"></i>
                    </div>
                    <div className="overflow-hidden flex-fill">
                      <div className="d-flex align-items-center justify-content-between">
                        <h2 className="counter text-info">
                          <CountUp end={5} />
                        </h2>
                        <span className="badge bg-info">Today</span>
                      </div>
                      <p>Today's Schedule</p>
                    </div>
                  </div>
                  <div className="d-flex align-items-center justify-content-between border-top mt-3 pt-3">
                    <p className="mb-0">
                      Next: <span className="text-info fw-semibold">Math</span>
                    </p>
                    <span className="text-light">|</span>
                    <p className="mb-0">
                      Time:{" "}
                      <span className="text-success fw-semibold">10:30</span>
                    </p>
                  </div>
                  <Link
                    to={routes.parentSchedule}
                    className="btn btn-info btn-sm mt-2 w-100"
                  >
                    View Schedule
                  </Link>
                </div>
              </div>
            </div>

            {/* Latest Grades Widget */}
            <div className="col-xxl-3 col-sm-6">
              <div className="card">
                <div className="card-body">
                  <div className="d-flex align-items-center">
                    <div className="avatar avatar-xl bg-primary-transparent me-2">
                      <i className="ti ti-trophy fs-2"></i>
                    </div>
                    <div className="overflow-hidden flex-fill">
                      <div className="d-flex align-items-center justify-content-between">
                        <h2 className="counter text-primary">
                          <CountUp end={88} />%
                        </h2>
                        <span className="badge bg-primary">Grade A</span>
                      </div>
                      <p>Grades Summary</p>
                    </div>
                  </div>
                  <div className="d-flex align-items-center justify-content-between border-top mt-3 pt-3">
                    <p className="mb-0">
                      Average:{" "}
                      <span className="text-primary fw-semibold">85%</span>
                    </p>
                    <span className="text-light">|</span>
                    <p className="mb-0">
                      Rank: <span className="text-success fw-semibold">15</span>
                    </p>
                  </div>
                  <Link
                    to={routes.studentGrades}
                    className="btn btn-primary btn-sm mt-2 w-100"
                  >
                    View Grades
                  </Link>
                </div>
              </div>
            </div>

            {/* Payment Summary Widget */}
            <div className="col-xxl-3 col-sm-6">
              <div className="card">
                <div className="card-body">
                  <div className="d-flex align-items-center">
                    <div className="avatar avatar-xl bg-info-transparent me-2">
                      <i className="ti ti-credit-card fs-2"></i>
                    </div>
                    <div className="overflow-hidden flex-fill">
                      <div className="d-flex align-items-center justify-content-between">
                        <h2 className="counter text-info">
                          $<CountUp end={450} />
                        </h2>
                        <span className="badge bg-info">Due</span>
                      </div>
                      <p>Payments Overview</p>
                    </div>
                  </div>
                  <div className="d-flex align-items-center justify-content-between border-top mt-3 pt-3">
                    <p className="mb-0">
                      Paid:{" "}
                      <span className="text-success fw-semibold">$2850</span>
                    </p>
                    <span className="text-light">|</span>
                    <p className="mb-0">
                      Due: <span className="text-danger fw-semibold">$450</span>
                    </p>
                  </div>
                  <Link
                    to={routes.paymentHistory}
                    className="btn btn-info btn-sm mt-2 w-100"
                  >
                    Quick Pay
                  </Link>
                </div>
              </div>
            </div>
          </div>

          {/* Secondary Widgets Row */}
          <div className="row">
            {/* Documents Overview Widget */}
            <div className="col-xxl-4 col-sm-6">
              <div className="card">
                <div className="card-header d-flex align-items-center justify-content-between">
                  <h5 className="card-title mb-0">Documents Overview</h5>
                  <div className="avatar avatar-sm bg-secondary-transparent">
                    <i className="ti ti-file-text"></i>
                  </div>
                </div>
                <div className="card-body">
                  <div className="mb-3">
                    <div className="d-flex justify-content-between align-items-center mb-2">
                      <span className="text-muted">New Documents</span>
                      <span className="badge bg-success">2</span>
                    </div>
                    <div className="d-flex align-items-center mb-2">
                      <i className="ti ti-file-text text-success me-2"></i>
                      <div className="flex-fill">
                        <p className="mb-0 fw-semibold">Report Card Q2</p>
                        <small className="text-muted">Dec 15, 2024</small>
                      </div>
                    </div>
                    <div className="d-flex align-items-center mb-3">
                      <i className="ti ti-file-text text-success me-2"></i>
                      <div className="flex-fill">
                        <p className="mb-0 fw-semibold">Certificate Request</p>
                        <small className="text-muted">Dec 12, 2024</small>
                      </div>
                    </div>
                  </div>
                  <div className="mb-3">
                    <div className="d-flex justify-content-between align-items-center mb-2">
                      <span className="text-muted">Pending Requests</span>
                      <span className="badge bg-warning">1</span>
                    </div>
                    <div className="d-flex align-items-center">
                      <i className="ti ti-clock text-warning me-2"></i>
                      <div className="flex-fill">
                        <p className="mb-0 fw-semibold">Transcript Request</p>
                        <small className="text-muted">Processing</small>
                      </div>
                    </div>
                  </div>
                  <Link
                    to={routes.parentDocuments}
                    className="btn btn-outline-secondary btn-sm w-100"
                  >
                    Manage Documents
                  </Link>
                </div>
              </div>
            </div>

            {/* Events Widget */}
            <div className="col-xxl-4 col-sm-6">
              <div className="card">
                <div className="card-header d-flex align-items-center justify-content-between">
                  <h5 className="card-title mb-0">Upcoming Events</h5>
                  <div className="avatar avatar-sm bg-primary-transparent">
                    <i className="ti ti-calendar-event"></i>
                  </div>
                </div>
                <div className="card-body">
                  <div className="d-flex align-items-center mb-3 p-2 bg-warning-light rounded">
                    <div className="avatar avatar-sm bg-warning me-3">
                      <i className="ti ti-clipboard-list text-white"></i>
                    </div>
                    <div className="flex-fill">
                      <h6 className="mb-1">Math Test</h6>
                      <p className="text-muted mb-0">Tomorrow • Chapter 5</p>
                    </div>
                  </div>
                  <div className="d-flex align-items-center mb-3 p-2 bg-info-light rounded">
                    <div className="avatar avatar-sm bg-info me-3">
                      <i className="ti ti-calendar text-white"></i>
                    </div>
                    <div className="flex-fill">
                      <h6 className="mb-1">Science Fair</h6>
                      <p className="text-muted mb-0">
                        Aug 15 • Annual Exhibition
                      </p>
                    </div>
                  </div>
                  <div className="d-flex align-items-center mb-3 p-2 bg-success-light rounded">
                    <div className="avatar avatar-sm bg-success me-3">
                      <i className="ti ti-users text-white"></i>
                    </div>
                    <div className="flex-fill">
                      <h6 className="mb-1">Parent Meeting</h6>
                      <p className="text-muted mb-0">Aug 9 • 3:00 PM</p>
                    </div>
                  </div>
                  <Link
                    to={routes.parentEventsCalendar}
                    className="btn btn-outline-primary btn-sm w-100"
                  >
                    View All Events
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* FAB Button */}
      <div className="floating-btn">
        <button
          className="btn btn-primary rounded-circle"
          style={{
            position: "fixed",
            bottom: "80px",
            right: "20px",
            width: "56px",
            height: "56px",
            zIndex: 1000,
          }}
          onClick={() => setShowFABModal(true)}
        >
          <i className="ti ti-plus"></i>
        </button>
      </div>

      {/* FAB Modal */}
      {showFABModal && (
        <div
          className="modal fade show d-block"
          style={{ backgroundColor: "rgba(0,0,0,0.5)" }}
        >
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Quick Actions</h5>
                <button
                  type="button"
                  className="btn-close"
                  onClick={() => setShowFABModal(false)}
                ></button>
              </div>
              <div className="modal-body">
                <div className="d-grid gap-2">
                  <button className="btn btn-primary text-start">
                    <i className="ti ti-message me-3"></i>
                    Send Message to Teacher
                  </button>
                  <button className="btn btn-info text-start">
                    <i className="ti ti-file-text me-3"></i>
                    Request Document
                  </button>
                  <button className="btn btn-warning text-start">
                    <i className="ti ti-calendar me-3"></i>
                    Request Meeting
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default ParentDashboard;
